import PropTypes from 'prop-types';
import React from 'react';
import {emphasize} from '@material-ui/core/styles/colorManipulator';

const VehicleIcon = ({color = '#000', heading = 0, height = 40, width = 40}) => {
  const accentColor = emphasize(color, 0.3);
  const contrastColor = emphasize(color, 1);
  // eslint-disable-next-line max-len
  const path = 'M18.333 28.333c0 .734.325 1.392.834 1.85v1.484c0 .458.375.833.833.833h.833c.46 0 .834-.375.834-.833v-.834h6.666v.834c0 .458.375.833.834.833H30c.458 0 .833-.375.833-.833v-1.484c.51-.458.834-1.116.834-1.85V20c0-2.917-2.984-3.333-6.667-3.333s-6.667.416-6.667 3.333v8.333zm2.917.834c-.692 0-1.25-.56-1.25-1.25 0-.692.558-1.25 1.25-1.25s1.25.558 1.25 1.25c0 .69-.558 1.25-1.25 1.25zm7.5 0c-.692 0-1.25-.56-1.25-1.25 0-.692.558-1.25 1.25-1.25s1.25.558 1.25 1.25c0 .69-.558 1.25-1.25 1.25zm1.25-5H20V20h10v4.167z';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 40 40">
      <g fill="none" fillRule="evenodd" transform="translate(-5 -5)">
        <circle cx="25" cy="25" r="20" fill={color} />
        <circle cx="25" cy="25" r="14" fill={accentColor} />
        <path d="M7 7h36v36H7z" />
        <path d="M15 15h20v20H15" />
        <path fill={contrastColor} d={path} />
      </g>
      <g
        fill="none"
        fillRule="evenodd"
        style={{transition: 'all 1s ease'}}
        transform={`rotate(${heading} 20 20) translate(-5 -5)`}
      >
        <path
          fill={contrastColor}
          d="M16 9.415c5.57-3.22 12.43-3.22 18 0l-1 1.73c-4.95-2.86-11.05-2.86-16 0l-1-1.73z"
        />
      </g>
    </svg>
  );
};

VehicleIcon.propTypes = {
  color: PropTypes.string,
  heading: PropTypes.number,
  height: PropTypes.number,
  width: PropTypes.number,
};

export default VehicleIcon;



// WEBPACK FOOTER //
// ./src/ondemand/components/VehicleIcon.js